export default [
	{
		// login form page
		companiesLabel: " ΕΤΑΙΡΕΙΕΣ",
		cardUsersLabel: "  ΚΑΤΟΧΟΙ ΚΑΡΤΑΣ",
		idleBrowserTitle: "Session Expired",
		idleBrowserMessage: "Η ιστοσελίδα είναι σε κατάσταση αδράνειας για 30'.",
		idleBrowserTimeLeft: "Απομένουν 15'' για την αποσύνδεση.",
		confirmButtonLabel: "ΕΠΙΒΕΒΑΙΩΣΗ",
		cardUserFieldLabel: "E-mail",
		userFieldLabel: "Όνομα Χρήστη",
		passwordFieldLabel: "Κωδικός Πρόσβασης",
		loginTitle: "Σύνδεση στο λογαριασμό μου",
		loginHelpLink: "Δεν μπορείς να συνδεθείς;",
		loginButtonLabel: "Σύνδεση",
		customerHelpPopup: "Εάν είστε πελάτης ή συνεργάτης μας, μπορείτε να συνδεθείτε στον λογαριασμό σας χρησιμοποιώντας τις πληροφορίες στο e-mail που λάβατε όταν υπογράψατε το συμβόλαιο μας. <br/> <br /> Οι πληροφορίες που χρησιμοποιούνται από προεπιλογή είναι:  <br /> <b> Χρήστης </b> = ο κωδικός πελάτη / συνεργάτη <br /> <b> Κωδικός πρόσβασης </b> = το ΑΦΜ της εταιρείας σας. <br /> Μπορείτε να αλλάξετε τον κωδικό πρόσβασης όταν συνδεθείτε για πρώτη φορά στον λογαριασμό σας. ",
		userLoginHelpPopup: "Γεια σας! Αλλάξαμε τον τρόπο που συνδέεστε στον λογαριασμό σας. Παρακαλούμε, δημιουργήστε έναν νέο λογαριασμό χρησιμοποιώντας το e-mail σας και κάποιες προσωπικές πληροφορίες. <br/> Θα μπορείτε να χρησιμοποιείτε τον ίδιο λογαριασμό για να συνδεθείτε στην εφαρμογή από το κινητό.	",
		downloadAppMessage: "Download the new mobile app Up Mobil",
		loadingPopupMessage: "Παρακαλώ περιμένετε. Η σελίδα φορτώνει…",
		erroMessage_bad_credentials: "Λάθος όνομα χρήστη ή κωδικός πρόσβασης ",
		erroMessage_user_blocked: "Ο χρήστης είναι μπλοκαρισμένος",
		erroMessage_invalid_grant: "Λάθος όνομα χρήστη ή κωδικός πρόσβασης ",
		erroMessage_invalid_login: "Λάθος όνομα χρήστη ή κωδικός πρόσβασης ",
		erroMessageResetPassword_bad_credentials: "Λάθος επωνυμία εταιρείας ή ΑΦΜ",
		erroMessage_undefined: " Σφάλμα στο server. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		erroMessage_invalid_client: " Σφάλμα στο server. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		erroMessage_server_error: " Σφάλμα στο server. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		erroMessageResetPassword_server_error: " Σφάλμα στο server. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		// create account page
		selectCardTitle: "Επιλέξτε την κάρτα σας",
		cardNumberFieldLabel: "Συμπληρώστε τον αριθμό της κάρτας σας",
		registrationCodeFieldLabel: "Fill in the last 6 digits of your personal ID number",
		registrationCheckDataTitle: "Ελέγξτε τις πληροφορίες ή τροποποιήστε τα δεδομένα",
		surnameFieldLabel: "Επώνυμο",
		lastNameField: "Όνομα",
		emailField: "E-mail",
		mobileField: "Κινητό τηλέφωνο",
		setPasswordTitle: "Παρακαλώ, εισάγετε κωδικό πρόσβασης",
		passwordField: "Κωδικός Πρόσβασης",
		confirmPasswordField: "Παρακαλώ επιβεβαιώστε τον κωδικό πρόσβασης",
		invalidPasswordMessage: "Λάθος κωδικός πρόσβασης",
		successMessageTitle: "Συγχαρητήρια!",
		registrationSuccessMessage: "Σας στείλαμε email στην διεύθυνση",
		resetPasswordSuccessMessage: "Ο κωδικός πρόσβασης έχει αλλάξει επιτυχώς",
		companyCodeLabel: "Κωδικός Πελάτη / Συνεργάτη",
		fiscalCodeLabel: "ΑΦΜ",
		resetPasswordSuccessMessageCompany: "Σας στείλαμε ένα email για να αλλάξετε τον κωδικό πρόσβασης. Παρακαλώ ανοίξτε τον σύνδεσμο που βρίσκεται στο email για να αλλάξετε τον κωδικό πρόσβασης",
		// cookies box
		cookiesBoxText: "To site μας χρησιμοποιεί cookies για να σας δείχνει προσωποποιημένο περιεχόμενο και για την ομαλή λειτουργία του traffic monitoring tool της Google.<br /> Παρακαλώ διαβάστε τους όρους χρήσης και σε περίπτωση που το κρίνετε απαραίτητο, ενημερώστε τις προτιμήσεις σας όσον αφορά τα cookies .",
		cookiesAcceptBotton: "ΑΠΟΔΟΧΗ",
		cookiesCookiePreferences: "Προτιμήσεις σχετικά με τα cookies",
		notificationsTitle: "Ειδοποιήσεις",
		notificationsTransactionalLabel: "Ειδοποιήσεις Συναλλαγών",
		notificationsMarketingTitle: "Ειδοποιήσεις για προωθητικές ενέργειες",
		notificationsLabel: "Ειδοποιήσεις",
		notificationsSMSLabel: "SMS",
		notificationsEmailLabel: "E-mail",
		notificationsCongrats: "Μπορείτε πλέον να ελέγχετε το υπόλοιπό σας και να εντοπίσετε ποιοι συνεργάτες δέχονται την κάρτα σας",
		completeRegistrationLogin: "Μπορείτε πλέον να χρησιμοποιείτε την εφαρμογή μας!",
		// page name
		dashboardName: "Πίνακας ελέγχου",
		cardsName: "Καρτες",
		servicesName: "Υπηρεσίες",
		faqName: "FAQ",
		settingsName: "Ρυθμίσεις",
		myAccountName: "Ο λογαριασμός μου",
		contactName: "Επικοινωνία",
		termsAndConditionsName: "Όροι χρήσης",
		personalDataPolicyName: "Πολιτική Προσωπικών Δεδομένων",
		logoutName: "Αποσύνδεση",
		// beneficiary dashboard
		cardBalanceBubbleTitle: "Υπόλοιπο Λογαριασμού",
		balanceBubbleTitle: "Το υπόλοιπό μου",
		currency: "&euro;",
		spentAmountMessage: "Ξοδέψατε {amount} € από την τελευταία σας ανανέωση",
		offersButtonLabel: "Προσφορές",
		partnersButtonLabel: "Συνεργάτες",
		recommendPartnersButtonLabel: "Προτείνετε έναν Συνεργάτη",
		expiringFundsTitle: "Ημερ/νία λήξης καρτών",
		transactionsListTitle: "Λίστα συναλλαγών",
		transactionListPeriodWeek: "πριν από {index} εβδομάδες",
		transactionListPeriodThisWeek: "Αυτή την εβδομάδα",
		transactionStatsTitle: "Στατιστικά Συναλλαγών",
		transactionNoTransactionsMessage: "Δεν έχετε κάνει συναλλαγές ακόμα",
		transactionStatsDDLThisMonth: "Τρέχων μήνας",
		transactionStatsDDLLastMonth: "Προηγούμενος μήνας",
		transactionStatsDDLLastMonths: "Προηγούμενοι {index} μήνες",
		transactionStatsDDLLast3Month: "Τελευταίοι 3 μήνες",
		transactionStatsDDLLastYear: "Προηγούμενος χρόνος",
		transactionStatsDDLCustom: "Προσωποποιημένο",
		loadingsReport: " Φορτίσεις Καρτών ανά Κάτοχο",
		downloadReport: "ΛΗΨΗ ΚΑΤΑΣΤΑΣΗΣ ΦΟΡΤΙΣΗΣ ΚΑΡΤΩΝ",
		// beneficiary cards
		cardsPageTitle: "Οι κάρτες μου",
		cardValidLabel: "Ισχύει μέχρι",
		// card svg text:
		expireAtLabel: "Λήγει στις",
		soldLabel: "Πωλήθηκε",
		// beneficiary services
		servicesPageTitle: "Υπηρεσίες",
		serviceName1: "Προτείνετε έναν Συνεργάτη",
		serviceName2: "Κατεβάστε την εφαρμογή",
		serviceName3: "MEMBER GET MEMBER",
		serviceName4: "Προσφορές ειδικά για εσάς",
		serviceName5: "Δίκτυο συνεργαζόμενων καταστημάτων",
		serviceName6: "Πείτε μας την γνώμη σας",
		textRecommendAParterner: "Θα θέλατε οι χρήστες να χρησιμοποιούν τα κουπόνια της Up Hellas σε κάποιο κατάστημα το οποίο δεν υπάρχει στο δίκτυό μας; \n Θα επικοινωνήσουμε μαζί τους άμεσα ώστε να μπορείτε να απολαμβάνετε τις υπηρεσίες μας και εκεί!",
		placeholderCompanyName: "Επωνυμία εταιρείας*",
		placeholderFieldOfActivity: "Δραστηριότητα*",
		placeholderDistrict: "Περιοχή*",
		placeholderCity: "Πόλη*",
		placeholderNameAndSurname: "Όνομα και Επώνυμο*",
		placeholderPhone: "Τηλέφωνο επικοινωνίας*",
		placeholderEmployerName: "Όνομα εργοδότη*",
		placeholderEmail: "E-mail*",
		placeholderVerificationCode: "Κωδικός Επιβεβαίωσης*",
		textButtonForm: "Αποστολή",
		textMemberGetMember: "Προτείνετε μας μια εταιρεία που δεν χρησιμοποιεί τα διατακτικές γεύματος και κερδίστε διατακτικές δώρου! \n Συμπληρώστε την παρακάτω φόρμα και κερδίστε διατακτικές δώρου Cadhoc, εάν η εταιρεία που προτείνατε ξεκινήσει να δίνει στους εργαζόμενούς της το προνόμιο των διατακτικών σίτισης. \n Ανάλογα τον αριθμό των εργαζομένων της εταιρείας που προτείνετε, μπορείτε να κερδίσετε:",
		titleYourCoordinates: "YOUR COORDINATES",
		titleRecommendedCompanyDetails: "Στοιχεία της εταιρείας που προτάθηκε",
		placeholderMemberCompanyName: "Όνομα εταιρείας*",
		placeholderMemberName: "Όνομα*",
		placeholderMemberRole: "Ρόλος*",
		placeholderMemberDistrict: "Περιοχή*",
		placeholderMemberCity: "Πόλη*",
		placeholderMemberPhone: "Τηλέφωνο επικοινωνίας*",
		placeholderMemberEmail: "E-mail*",
		placeholderComment: "Μήνυμα*",
		placeholderMemberVerificationCode: "Κωδικός Επιβεβαίωσης*",
		textAcceptPrivacyPolicy: "Συμφωνώ στην συλλογή και χρήση των παραπάνω δεδομένων από την Up Hellas σύμφωνα με",
		textPrivacyPolicy: "Πολιτική Απορρήτου",
		textReadAndAgree: " Έχω διαβάσει και συμφωνώ με την",
		textCampaignRegulations: '" Ai recomandat, ai castigat!" campaign regulations, including the Section 7 regarding the personal data policy.',
		textFeedback: "Η γνώμη σας είναι απαραίτητη για να μπορέσουμε να βελτιώσουμε τις υπηρεσίες που σας παρέχουμε. ",
		chooseOptionLabel: "Διαλέξτε προϊόν",
		noOffersMessage: "Δεν υπάρχουν διαθέσιμες προσφορές αυτή την στιγμή.",
		// pin || card request message
		pinReqMsg: " Έχετε ήδη αιτηθεί έναν κωδικό PIN. Παρακαλώ επικοινωνήστε με τον εργοδότη σας για επαλήθευση",
		cardReqMsg: " Έχετε ήδη αιτηθεί μια καινούργια κάρτα. Παρακαλώ επικοινωνήστε με τον εργοδότη σας για επαλήθευση",
		// confirm pin || card request message
		confirmPinReqMsg: "Είστε σίγουρος/σίγουρη ότι θέλετε να εκδόσετε ξανά τον κωδικό PIN σας; ",
		confirmCardReqMsg: "Είστε σίγουρος/σίγουρη ότι θέλετε να εκδόσετε μια καινούργια κάρτα; ",
		// error pin || card request message
		errorPinOrCardReqMsg: "Υπάρχει ένα πρόβλημα στον server μας. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		selectDate: "Επιλέξτε ημερ/νία",
		// Buttons card options
		activeCardText: "<br />  ΕΝΕΡΓΟΠΟΙΗΣΗ <br /> ΚΑΡΤΑΣ",
		blockCardText: " <br /> ΚΛΕΙΔΩΜΑ <br /> ΚΑΡΤΑΣ",
		unblockCardText: "<br /> ΞΕΚΛΕΙΔΩΜΑ <br /> ΚΑΡΤΑΣ",
		requestPinText: "<br /> ΑΙΤΗΣΗ ΓΙΑ <br /> PIN",
		requestCardText: "<br /> ΑΙΤΗΣΗ ΓΙΑ <br /> ΚΑΡΤΑΣ",
		faqText: "<br />FAQ",
		// Success message
		successMsg: " Η αίτηση για το νέο {PIN} έχει επιτυχώς σταλλεί <br /> στον εργοδότη σας και θα επανεκδοθεί μετά την έγκρισή του",
		// Chart
		expenseText: "Έξοδο",
		soldText: "Πωλήθηκε",
		// Download Apps
		downloadApps: "Κατεβάστε την εφαρμογή για κινητά",
		// Setting Items Title
		settingPageTitle: "Ρυθμίσεις",
		settingItem1: "Ο λογαριασμός μου",
		settingItem2: " Προωθητικές ειδοποιήσεις",
		settingItem3: "ΑΛΛΑΓΗ ΚΩΔΙΚΟΥ ΠΡΟΣΒΑΣΗΣ",
		settingItem4: "Διαγραφή λογαριασμού",
		// Change Password Form
		placeholderOldPassword: "Παλιός κωδικός πρόσβασης",
		deleteAccountText: "Είστε σίγουρος ότι θέλετε να διαγράψετε τον λογαριασμό σας;",
		passwordCriteria1Text: "Εισάγετε τουλάχιστον 8 χαρακτήρες",
		passwordCriteria2Text: "Εισάγετε τουλάχιστον ένα γράμμα στον κωδικό πρόσβασης",
		passwordCriteria3Text: "Εισάγετε τουλάχιστον έναν αριθμό στον κωδικό πρόσβασης",
		// Read More || Read less
		readMore: "Διαβάστε περισσότερα",
		readLess: "Διαβάστε λιγότερα",
		// Confirm activate OR block OR unblock card request message
		confirmActvatedCardReqMsg: "Είστε σίγουρος/σίγουρη ότι θέλετε να ενεργοποιήσετε την κάρτα σας;",
		confirmBlockCardReqMsg: "Είστε σίγουρος/σίγουρη ότι θέλετε να κλειδώσετε την κάρτα σας;",
		confirmUnblockCardReqMsg: "Είστε σίγουρος/σίγουρη ότι θέλετε να ξεκλειδώσετε την κάρτα σας;",
		msgEmailSuccess: "Το email σας στάλθηκε επιτυχώς",
		notificationMessage: "Δεν έχετε κάποιο μήνυμα",
		// customer page
		// menu items
		uploadFileLabel: "Upload file",
		ordersName: "Παραγγελίες",
		beneficiariesName: "Δικαιούχοι",
		deliveryPointsName: "Σημεία Παράδοσης",
		deliveryPointsDescription: "Δείτε τα σημεία παράδοσης των παραγγελιών σας",
		productTypePaper: "Εντυπες διατακτικές",
		productTypeCard: "Κάρτες",
		deliveryPointAddressTitle: "Διεύθυνση",
		deliveryPointAddressStreet: "Οδός",
		deliveryPointAddressCity: "Πόλη",
		deliveryPointAddressDistrict: "Περιοχή",
		deliveryPointAddressPostalCode: "Ταχυδρομικός Κώδικας",
		deliveryPointContactTitle: "Υπεύθυνος  επικοινωνίας",
		deliveryPointContactSurname: "Όνομα",
		deliveryPointContactName: "Επώνυμο",
		deliveryPointContactEmail: "Email",
		deliveryPointContactMobile: "Τηλέφωνο επικοινωνίας",
		deliveryPointNoBeneficiaries: "Αριθμός δικαιούχων",
		invoicesName: "Τιμολόγια",
		newOrderName: "ΝΕΑ ΠΑΡΑΓΓΕΛΙΑ",
		settingCompanyItem1: "Πληροφορίες εταιρείας",
		settingCompanyItem2: "Οι συμβάσεις μου",
		settingCompanyItem3: "Αλλαγή κωδικού πρόσβασης ",
		averageChartLabel: "Αξία",
		countChartLabel: "Συναλλαγές",
		lastInvoicesTitle: "Τελευταία τιμολόγια",
		pendingInvoicesTitle: "Προς πληρωμή",
		invoiceSeriesHeader: "Series",
		invoiceNumberHeader: "Αρ. τιμολογίου",
		invoiceDateHeader: "Ημερ/νία έκδοσης τιμολογίου",
		invoiceStatusHeader: "Πληρωμή",
		invoiceAmountHeader: "Συνολικό ποσό",
		invoiceDownloadPDFHeader: "Κατεβάστε το σε pdf",
		invoiceDownloadXMLHeader: "Κατεβάστε το σε xml",
		seeAllInvoicesButtonLabel: "Προβολή όλων",
		customerDashboardCardStats: "Σύνοψη παραγγελίας",
		statsCardsActive: "Ενεργές κάρτες",
		statsCardsBlocked: "Κλειδωμένες κάρτες",
		statsCardsInactive: "κάρτες προς ενεργοποίηση",
		statsCardsSMS: "Cards with SMS option",
		recommendationsTitle: "Προτάσεις",
		averageTransactionAmount: "Μέσος όρος παραγγελίας",
		averageTransactionNumber: "Μέσος όρος συναλλαγών",
		usageVolumeChartTitle: "Πλήθος συναλλαγών",
		usagePerRegion: "Όγκος συναλλαγών ανά περιοχή",
		topSellers: "Τα καταστήματα με τις περισσότερες επισκέψεις",
		noTransactionsTitle: "Δεν έχουν γίνει συναλλαγές για την περίοδο που έχετε επιλέξει",
		noTransactionsMessage: "Παρακαλώ επιλέξτε μια νέα περίοδο για να δείτε τις συναλλαγές που έχουν γίνει",
		downloadLinkText: "Λήψη",
		noInvoicesMessage: "Δεν υπάρχουν τιμολόγια για αυτό το προϊόν",
		// Dashboard
		dashboardInfoTitle_TOTAL_ORDERS_COUNT: "{value}",
		dashboardInfoTitle_TOTAL_ORDERS_AMOUNT: "{value} &euro;",
		dashboardInfo_TOTAL_ORDERS_COUNT: " Παραγγελίες από <br/> την αρχή της χρονιάς",
		dashboardInfo_TOTAL_ORDERS_AMOUNT: " Παραγγελίες από <br/>  την αρχή της χρονιάς",
		productBrand_gift: "Gift",
		productBrand_rewards: "Rewards",
		// Orders
		deliveryAddress: "Διεύθυνση αποστολής",
		invoiceAddress: "Διεύθυνση τιμολόγησης",
		product: "Προϊόν",
		ordersTableHeaderDate: "Ημερ/νία",
		ordersTableHeaderNumber: "Αρ. Παραγγελίας",
		ordersTableHeaderProduct: "Προϊόν",
		ordersTableHeaderType: "Είδος",
		ordersTableHeaderAmount: "Αξία",
		ordersTableHeaderStatus: "Κατάσταση",
		ordersTableHeaderAddress: "Διεύθυνση αποστολής",
		ordersTableHeaderInvoice: "Τιμολόγιο",
		ordersTableHeaderTrack: "Track & Trace",
		ordersTableHeaderProform: "Προτιμολόγιο",
		proformNumber: "Αρ. προτιμολογίου",
		numberTotalTickets: "Συνολικός αριθμός διατακτικών",
		numberTotalCards: "Συνολική ποσότητα καρτών",
		nominalValue: "Συνολική καθαρή αξία είδους",
		nominalValueRewards: "Συνολική αξία φόρτισης",
		groupTickets: "Ομαδοποίηση κουπονιών",
		logo: "Logo",
		messageTicket: "Μήνυμα πάνω στα κουπόνια",
		totalPayment: "Σύνολο",
		beneficiariesTitle: "Δικαιούχοι καρτών",
		beneficiariesDescription: "Διαχείριση δικαιούχων καρτών",
		beneficiariesInfoTitle: "Θέλετε να προσθέσετε έναν καινούριο δικαιούχο;",
		noOrdersMessage: " Δεν βρέθηκαν παραγγελίες για την επιλεγμένη περίοδο. Παρακαλώ επιλέξτε άλλη περίοδο.",
		beneficiariesInfoMessage: "Μπορείτε να προσθέσετε έναν δικαιούχο, μόνο αφού έχει εκδοθεί η κάρτα του. Σε περίπτωση που έχετε κάποιον καινούργιο εργαζόμενο, μπορείτε να μπείτε στο μενού έκδοσης κάρτας ώστε να παραγγείλετε μια καινούργια κάρτα.",
		noBeneficiariesInfoMessage: "Δεν υπάρχουν δικαιούχοι με τα επιλεγμένα κριτήρια",
		beneficiariesFilterTitle: "Επιλογές",
		beneficiariesFilterCardType: "Όνομα Προϊόντος",
		beneficiariesFilterCardStatus: "Κατάσταση",
		beneficiariesFilterProductType: "Τύπος κάρτας",

		beneficiariesFilterDeliveryAddress: "Διεύθυνση αποστολής",
		beneficiariesFilterHddid: "Search by multiple employee ID# separated by comma",
		beneficiariesFileUploadText: "Upload file with columns: hddid, first name, last name",
		beneficiariesFilterKeyword: "Αναζήτηση βάσει ονόματος ή Κωδικού Κατόχου Κάρτας",
		beneficiariesTableTextOnCard: "Όνομα κάρτας",
		beneficiariesTableDetails: "Στοιχεία ατομικού φακέλου",
		beneficiariesTableAmount: "Αξία φόρτισης",
		beneficiariesTableSurname: "Όνομα",
		beneficiariesTableName: "Επώνυμο",
		beneficiariesTableCNP: "Κωδικός Κατόχου Κάρτας",
		beneficiariesTableCard: "Κάρτα",
		beneficiariesTableExpire: "Expire date",
		beneficiariesTableCardStatus: "Status κάρτας",
		beneficiariesTableAction: "Ενέργειες",
		beneficiariesTableStatus: "Κατάσταση Δικαιούχου",
		beneficiariesTableSeeMore: "Λεπτομέρειες",
		beneficiariesTableDownload: "Κατεβάστε την λίστα",
		beneficiariesTableNoOfTickets: "Αριθμός διατακτικών",
		beneficiariesTableTicketValue: "Ποσό",
		beneficiariesTableTotalValue: "Συνολική αξία",
		beneficiariesTableAddress: "Διεύθυνση",
		beneficiariesTableAddress1: "Keímeno parathýrou 1",
		beneficiariesTableAddress2: "Keímeno parathýrou 2",
		beneficiariesTableAddressCity: "Keímeno parathýrou 3",
		beneficiariesTableAddressPostalCode: "Keímeno parathýrou 4",
		beneficiariesTableMobile: "Τηλεφωνικό νούμερο",
		beneficiariesTableEmail: "E-mail",
		beneficiariesTableType: "Product Type",
		beneficiariesTableDigital_true: "Digital",
		beneficiariesTableDigital_false: "Physical",

		beneficiariesSelectAll: "Select all beneficiairies",
		beneficiariesDeselectAll: "De-select all beneficiaries",

		backButtonLabel: "Πίσω",
		cardStatus_A: "Ενεργή",
		cardStatus_B: "Κλειδωμένη",
		cardStatus_F: "Κλειδωμένη",
		cardStatus_D: "Ακυρωμένη",
		cardStatus_C: "Προς ενεργοποίηση",
		cardStatus_J: "Ακυρωμένη ",
		cardStatus_L: "Ακυρωμένη ",
		cardStatus_X: "Ληγμένες",
		cardStatus_PF: "Προτιμολόγιο ",
		cardStatus_E: " Υπο επεξεργασία  ",
		cardStatus_I: " Υπο επεξεργασία  ",
		cardStatus_M: " Υπο επεξεργασία  ",
		cardStatus_N: " Υπο επεξεργασία  ",
		cardStatus_O: " Υπο επεξεργασία  ",
		cardStatus_P: " Υπο επεξεργασία  ",
		cardStatus_R: " Υπο επεξεργασία  ",
		cardStatus_S: " Υπο επεξεργασία  ",
		cardStatus_RN: " Λήγει σύντομα ",
		cardStatus_RC: " Επανεκδόστε την κάρτα ",
		cardStatus_OH: "Κλειδωμένη",
		cardStatus_RP: "Επανεκδώστε το PIN",
		cardStatus_: "Επιλέξτε…",
		cardStatus_unknown: " Υπο επεξεργασία  ",
		productType_D: "Digital",
		productType_P: "Physical",
		productType_: "Επιλέξτε…",
		beneficiaryStatus_Active: "Ενεργή",
		beneficiaryStatus_Inactive: "Προς ενεργοποίηση",
		actionsText: " Για τους {count} δικαιούχους που έχετε επιλέξει θέλετε να: ",
		beneficiariesActionSelect: "Ενέργεια",
		newOrderActionSelect: "Για Καταχώριση πιέστε +",
		cardsAction_CHOOSE: " Επιλέξτε... ",
		cardsAction_ACT: " Ενεργοποίηση επιλεγμένων καρτών  ",
		cardsAction_DEACT: "Καταργήστε οριστικά τις επιλεγμένες κάρτες",
		cardsAction_REPL: " Επανέκδοση επιλεγμένων καρτών  ",
		cardsAction_PIN: "Επανέκδοση PIN",
		cardsAction_VALIDATE_REPL: "Επιβεβαίωση επανέκδοσης κάρτας",
		cardsAction_VALIDATE_PIN: "Επιβεβαίωση επανέκδοσης PIN",
		cardsAction_REN: " Ακύρωση επανέκδοσης  ",
		cardsAction_ACT_ALL: "Ενεργοποίηση όλων των καρτών",
		cardsAction_BLOK: "Κλείδωμα επιλεγμένων καρτών",
		cardsAction_DEBLOK: "Ξεκλείδωμα επιλεγμένων καρτών",
		cardsAction_CLO: "Επανέκδοση της digital κάρτας σε physical",
		cardsAction_DELETE_BENEFICIARY: "Διαγραφή επιλεγμένων δικαιούχων",
		cardsActionDeactCardMessage: "Προχωράτε σε οριστική ακύρωση κάρτας και η ενέργεια αυτή θα είναι μη αναστρέψιμη. Είστε σίγουροι ότι θέλετε να προχωρήσετε;",
		// beneficiary details from client
		transferUserLabel: "Μεταφορά",
		suspendUserLabel: "Απενεργοποίηση",
		deleteUserLabel: " Διαγραφή ",
		cnpFieldLabel: "Κωδικός Κατόχου Κάρτας",
		saveChangesLabel: "Αποθήκευση",
		editButtonLabel: "Επεξεργασία",
		cancelChangesLabel: "Ακύρωση τροποποιήσεων",
		deliveryPointLabel: "Διεύθυνση αποστολής",
		cardNumberLabel: "Αριθμός κάρτας",
		cardExpiryLabel: "Λήγει στις",
		reissueCardButtonLabel: "Επανέκδοση Κάρτας",
		reissuePINButtonLabel: "Επανέκδοση PIN",
		validateReissueCardButtonLabel: "Επιβεβαίωση επανέκδοσης κάρτας",
		validateReissuePINButtonLabel: "Επιβεβαίωση επανέκδοσης PIN",
		notificationsChooseLabel: "Αποστολή επιβεβαιώσεων με SMS για συναλλαγές και επαναφόρτωση κάρτας",
		notificationsChooseOptionYes: "Ναι",
		notificationsChooseOptionNo: "Όχι",
		beneficiaryOrderHistory: "Ιστορικό παραγγελιών και αλλαγών",
		orderType_NEW: "Παραγγελία καρτών",
		orderType_NEWCR: "Επαναφόρτιση καρτών",
		orderType_PIN: "Επανέκδοση PIN",
		orderType_REPL: " Επανέκδοση κάρτας  ",
		orderType_VALIDATE_REPL: "Επιβεβαίωση επανέκδοσης κάρτας",
		orderType_VALIDATE_PIN: "Επιβεβαίωση επανέκδοσης PIN",
		orderType_MODIFY_DATA: "Αλλάξτε τις πληροφορίες δικαιούχου",
		lastToppingUpLabel: "Τελευταία επαναφόρτωση κάρτας",
		replacementLabel: "Επανέκδοση",
		confirmActionBeneficiary_PIN: " Είστε σίγουρος/σίγουρη ότι θέλετε να επανεκδώσετε καινούργιο PIN για την {product} κάρτα; ",
		confirmActionBeneficiary_REPL: " Είστε σίγουρος/σίγουρη ότι θέλετε να επανεκδώσετε καινούργια κάρτα {product} ; ",
		confirmActionBeneficiary_SMS: " Είστε σίγουρος/σίγουρη ότι θέλετε να αλλάξετε την επιλογή σας σχετικά με την λήψη SMS για την κάρτα {product} ; ",
		confirmActionBeneficiary_DELETE: "Έχετε επιλέξει να διαγράψετε αυτόν το δικαιούχο. <br /><br /> <b>Προσοχή!</b> Αυτή η ενέργεια είναι μη αναστρέψιμη και δεν θα έχετε πρόσβαση σε μελλοντικές πληροφορίες όσον αφορά τον δικαιούχο από τη στιγμή που θα τον διαγράψετε.<br /> Η κάρτα του δικαιούχου θα παραμείνει ενεργή και θα έχει τη δυνατότητα χρήσης της κάρτας.<br /><br /> Είστε σίγουρος/σίγουρη ότι θέλετε να διαγράψετε αυτόν τον δικαιούχο; <br />",
		confirmActionBeneficiary_DELETE_BENEFICIARY:
			"Έχετε επιλέξει να διαγράψετε τους επιλεγμένους δικαιούχους. <br /><br /> <b>Προσοχή!</b> Αυτή η ενέργεια είναι μη αναστρέψιμη και δεν θα έχετε πρόσβαση σε μελλοντικές πληροφορίες όσον αφορά τον δικαιούχο από τη στιγμή που θα τον διαγράψετε.<br /> Η κάρτα του δικαιούχου θα παραμείνει ενεργή και θα έχει τη δυνατότητα χρήσης της κάρτας. <br /><br /> Είστε σίγουρος/σίγουρη ότι θέλετε να διαγράψετε τους δικαιούχους; <br />",
		confirmActionBeneficiary_INACTIVATE: " Είστε σίγουρος/σίγουρη ότι θέλετε να κλειδώσετε αυτόν τον χρήστη; <br/> Θα είστε σε θέση να τον ξεκλειδώσετε αργότερα. ",
		confirmActionBeneficiary_ACTIVATE: " Είστε σίγουρος/σίγουρη ότι θέλετε να ενεργοποιήσετε αυτόν τον χρήστη; ",
		successActionBeneficiary_PIN: "Το αίτημα για επανέκδοση PIN για την κάρτα {product} έχει καταγραφεί. Μπορείτε να δείτε την εξέλιξη του αιτήματός σας στο μενού Παραγγελιών ",
		successActionBeneficiary_REPL: " Το αίτημά σας για την επανέκδοση κάρτας {product} έχει καταχωρηθεί. Μπορείτε να ελέγχετε την πορεία του στο μενού παραγγελιών.",
		successActionBeneficiary_DELETE: " Ο δικαιούχος έχει επιτυχώς διαγραφτεί.  ",
		successActionBeneficiary_INACTIVATE: " Ο δικαιούχος έχει απενεργοποιηθεί επιτυχώς. ",
		successActionBeneficiary_SMS: " Η επιλογή αποστολής SMS για την {product} κάρτα σας έχει καταχωρηθεί.",
		errorActionBeneficiary_CRRR: "Υπάρχει ήδη ένα αίτημα επανέκδοσης κάρτας {product} καταχωρημένο σήμερα.",
		errorActionBeneficiary_ASFI: " Η επιλογή αποστολής SMS για την {product} κάρτα σας είναι άκυρη.",
		errorActionBeneficiary_CRBS: " Ακυρώθηκε το αίτημα για επανέκδοση κάρτας",
		errorActionBeneficiary_CRNF: " Η κάρτα για την οποία ζητήσατε επανέκδοση δεν υπάρχει",
		errorActionBeneficiary_409: " Έχει ήδη καταχωρηθεί αίτημα επανέκδοσης κάρτας {product} σήμερα.",
		errorActionBeneficiary_CHOOSE: "Παρακαλώ επιλέξτε κάτι από τα παρακάτω",
		errorActionBeneficiary_NOADDRESS: "Παρακαλώ επιλέξτε διεύθυνση αποστολής",
		errorActionBeneficiary_PROFORM: " Σφάλμα συστήματος κατά το κατέβασμα του αρχείου. Παρακαλώ δοκιμάστε αργότερ από το μενού παραγγελιών.",
		errorActionBeneficiary_500: " Υπάρχει ένα πρόβλημα στον server μας. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		errorActionBeneficiary_ERROR: "During the request there were encoutered the following errors: ",
		errorActionBeneficiary_NO_FILE: " Εισάγετε ένα έγκυρο αρχείο παραγγελίας ",
		errorActionBeneficiary_FIRSTNAME: "The first name value is incorrect. It must contain only latin characters",
		errorActionBeneficiary_LASTNAME: "The last name value is incorrect. It must contain only latin characters",
		errorActionBeneficiary_VALUE: "Η αξία του ποσού είναι πολύ μεγάλη.",
		errorActionBeneficiary_VALUE_MANDATORY: "Συμπληρώστε αξία φόρτισης.",
		errorActionBeneficiary_VALUE_MAX_REWARDS: "Συμπληρώστε έως &euro;150.",
		errorActionBeneficiary_VALUE_MAX_PAPER: "Συμπληρώστε έως &euro;175.",
		errorActionBeneficiary_MAX_TICKETS_BOOKLET: "Ο αριθμός των κουπονιών στο βιβλιάριο ξεπερνά τα 35 κουπόνια",
		errorActionBeneficiary_NO_DATA: " πατήσετε το σύμβολο + κάτω από την καταχώριση για να προχωρήσετε την παραγγελία σας. ",
		errorActionBeneficiary_NO_POSTPONE_DATE:
			"You must choose a date starting tomorrow at which your proforma should be generated. ",
		errorActionBeneficiary_NO_MONTH: " Παρακαλώ εισάγετε τον μήνα στον οποίο θέλετε να γίνει η φόρτιση των καρτών.  ",
		errorActionBeneficiary_EMAIL_INVALID: " Η διεύθυνση email δεν είναι έγκυρη ",
		errorActionBeneficiary_MOBILE_INVALID: " Ο αριθμός κινητού δεν είναι έγκυρος ",
		errorActionBeneficiary_EMAIL_PHONE_MANDATORY: "  Το Email ή ο αριθμός κινητού είναι υποχρεωτικό να συμπληρωθούν.",
		errorActionBeneficiary_EMAIL_PHONE_UNIQUE: " Παρακαλώ συμπληρώστε μόνο ένα από τα δύο πεδίο email ή κινητό τηλέφωνο ",
		errorActionBeneficiary_PHONE_UNIQUE: " The mobile phone for all beneficiaries must be unique",
		errorActionBeneficiary_LOAD_VALUE:
			"Δεν επιτρέπεται η χρήση 3ψήφιας αξίας (επιτρέπεται έως 99 euros)",
		errorActionBeneficiary_MILLESIME:
			"Λόγω προγραμματισμένων αναβαθμίσεων στην πλατφόρμα μας, η δυνατότητα καταχώρησης παραγγελιών θα είναι προσωρινά μη διαθέσιμη. Θα επανέλθει κανονικά μετά τις 11:00. Ευχαριστούμε για την κατανόησή σου.",
		errorActionBeneficiary_EMPTY:
			"Πρέπει να πατήσετε το σύμβολο + κάτω από την καταχώριση για να προχωρήσετε την παραγγελία σας.",
		errorActionBeneficiary_TICKET:
			"Υπάρχει ένα σφάλμα με την παραγγελία που προσπαθείτε να ανεβάσετε. <br /> Παρακαλώ επικοινωνήστε μαζί μας δημιουργώντας ένα αίτημα εδώ: <br /> <a href='https://uphellas.atlassian.net/servicedesk/customer/portal/15' target='_blank'> Business Portal Support - Jira Service Management (atlassian.net) </a>",
		reissuePINBeneficiaryTitle: " Ο χρήστης αυτός έχει αιτηθεί {count} φορές PIN . ",
		reissuePINBeneficiaryMessage: " Παρακαλώ δείτε παρακάτω, στο μενού καρτών, τα αιτήματα προς έγκριση. ",
		reissueCardBeneficiaryTitle: " Ο χρήστης αυτός έχει αιτηθεί {count} φορές κάρτα . ",
		suspendedBeneficiaryTitle: "Ο χρήστης απενεργοποιήθηκε.",
		suspendedBeneficiaryMessage: " Θέλετε να απενεργοποιήσετε αυτόν τον χρήστη; ",
		reactivateBeneficiaryButtonLabel: " ΕΝΕΡΓΟΠΟΙΗΣΗ ",
		actionConfirmMessage: " Παρακαλώ επιβεβαιώστε την λίστα με τους χρήστες στην οποία θέλετε να γίνει η αλλαγή. ",
		actionCLOMessage: "H νέα κάρτα θα παραδοθεί στη διεύθυνση με κωδικό {code}",
		actionSuccessMessage: " Η {action} καταχωρήθηκε.",
		"CARD.ERROR.CONFIG":
			"Παρουσιάστηκε πρόβλημα με την παραγγελία καθώς δεν φαίνεται συγκεκριμένη διεύθυνση καταχώρησης στο σύστημα. Παρακαλώ επικοινωνήστε με το chat για την επίλυση του προβλήματος. Σας ευχαριστούμε.",
		"CARD.NOT.VALIDSTATUS": " Η ενέργεια που επιλέξατε για την κάρτα του {name} δεν μπορεί να πραγματοποιηθεί λόγω του status της  κάρτας.",
		"CARD.NOT.VALIDVIRTUAL":
			"The card for the beneficiary with id {name} must be a digital card for the selected action.",
		"CARD.NOT.FOUND": "Η κάρτα του χρήστη {name} δεν βρέθηκε.",
		"CARD.NOT.PRODUCED": "Η κάρτα του χρήστη {name} δεν βρέθηκε.",
		"CARD.ERROR.NOT.FOUND": "Η κάρτα του χρήστη {name} δεν βρέθηκε.",
		"CARD.ERROR.NOTFOUND": "Η κάρτα του χρήστη {name} δεν βρέθηκε.",
		"CARD.NOT.VALIDTODAY": " Η ενέργεια που επιλέξατε για την κάρτα του {name} δεν μπορεί να πραγματοποιηθεί λόγω του status της  κάρτας.",
		"CARD.ERROR.MANDATORY": " Το {field} πεδίο είναι υποχρεωτικό για τον κάτοχο κάρτας με κωδικό {name}.",
		"CARD.ERROR.ALREADY": "Η κάρτα για τον κάτοχο με αριθμό μητρώου {name} υπάρχει ήδη.",
		"CARD.ERROR.ALREADY.REPL":
			"Η εντολή επανέκδοσης έχει ήδη καταχωρηθεί.",
		"CARD.ERROR.TRANSFER": "Η παραγγελία σας δεν μπορεί να προχωρήσει, διότι ο δικαιούχος {name}  έχει μεταφερθεί σε άλλη εταιρεία. Παρακαλώ προχωρήστε είτε αφαιρώντας τον από την παραγγελία ή δοκιμάστε ξανά αύριο.",
		"CARD.ERROR.LENGTH": " Το όνομα είναι πολύ μεγάλο για τον κάτοχο με κωδικό {name}",
		"CARD.ERROR.LOAD.MONTH": "Η ποσότητα διατακτικών στο καρνέ στη σειρά {X} ξεπερνά τα 35 κουπόνια",
		"CARD.ERROR.LOAD.VALUE": "Η αξία του ποσού για τον δικαιούχο με αναγνωριστικό {name} είναι μεγαλύτερη από το",
		"CARD.ERROR.LOAD.VALUE.MIN": " Η αξία για τον κάτοχο με κωδικό {name} είναι πολύ μικρό",
		"CARD.ERROR.MAX.YEARLY":
			"Η συνολική αξία φόρτισης ανά δικαιούχο {name} δεν μπορεί να ξεπερνά τα 1.752€/έτος για την Up EAT ή τα 300€/έτος για την Up Gift.",
		"CARD.ERROR.TOO.MANY.DIGITS": "Η αξία του ποσού για τον δικαιούχο με αναγνωριστικό {name} πρέπει να έχει το πολύ 3 ψηφία (συμπεριλαμβανομένων των δεκαδικών)",
		"CARD.ERROR.NOT.VALID.REISSUE": "Η κάρτα για τον δικαιούχο με αναγνωριστικό {name} δεν μπορεί να επανεκδοθεί. Παρακαλώ επικοινωνήσετε με την Up Hellas.",
		"CARD.ERROR.INVALID": "Το {field} πεδίο είναι λάθος για τον εργαζόμενο με κωδικό {name}.,",
		"CARD.ERROR.DUPLICATE": "Η τιμή {name} είναι διπλή.",
		"CARD.ERROR.LATIN": "Το ονοματεπώνυμο του κατόχου κάρτας πρέπει να είναι {name} σε λατινικούς χαρακτήρες",
		"CARD.ERROR.SPACE": "Το εμφανιζόμενο κείμενο πρέπει να περιέχει τουλάχιστον 2 λέξεις.",
		"CARD.EXPIRY.TODAY": "Η επανέκδοση που επιλέξατε δεν μπορεί να ολοκληρωθεί σήμερα λόγω ημερ/νιας λήξης των καρτών. Παρακαλώ προχωρήστε στην επανέκδοση τους από αύριο",

		"CARD.ERROR.VALUE.MAX.REWARDS": "Συμπληρώστε έως &euro;150.",
		"CARD.ERROR.LOAD.VALUE.INPUT": "Η αξία του ποσού είναι πολύ μεγάλη.",
		"CARD.ERROR.TOO.MANY.CARDS.MOBILE": "You cannot order more than one rewards card for the same phone number (see line {name}).",

		seeMoreLabel: "MORE",
		seeLessLabel: "LESS",

		CNP: " κωδικός κατόχου",
		ADDRESS: " κωδικός διεύθυνσης,",
		NAME: "όνομα",
		VOUCHERS: "έντυπες διατακτικές",
		NOMINAL_VALUE: "καθαρή αξία",
		modifiyDataSucceess: " Οι πληροφορίες του χρήστη άλλαξαν.",
		deleteDataSucceess: " Ο χρήστης διαγράφηκε.",
		// Orders
		goToOrdersButton: "ΟΙ ΠΑΡΑΓΓΕΛΙΕΣ ΜΟΥ",
		details: "Λεπτομέρειες",
		pendingOrdersMessage: " {noOrders} παραγγελίες σε αναμονή",
		pendingOrdersTitle: " Εκκρεμείς παραγγελίες",
		pendingOrdersNoOrders: " Δεν υπάρχουν εκκρεμείς παραγγελίες",
		ordersHistoryTitle: " Ιστορικό Παραγγελιών",
		cancelOrderButtonLabel: "Διαγραφή",
		trackOrderButtonLabel: " Βρες την παραγγελία μου",
		reportButtonLabelPaper: "Κατάσταση απόδοσης διατακτικών",
		reportButtonLabelCard: " Κατάσταση φόρτισης καρτών",
		invoiceButtonLabel: "Τιμολόγιο",
		proformaButtonLabel: "Προτιμολόγιο",
		orderDescription: "Καταχωρήθηκε στις",
		companySettingsTitle: "Ρυθμίσεις",
		VATLabel: "ΑΦΜ",
		deliveryAddressLabel: "Κύρια διεύθυνση αποστολής",
		invoiceAddressLabel: "ΔΟΥ",
		changePasswordLabel: "Αλλαγή κωδικού πρόσβασης ",
		changePasswordSuccess: "Ο κωδικός πρόσβασης άλλαξε με επιτυχία",
		errorPassword_PASS: " Ο νέος κωδικός πρόσβασης δεν είναι ίδιο με τον κωδικό επιβεβαίωσης.",
		errorPassword_500: "Υπάρχει ένα πρόβλημα στον server μας. <br /> Παρακαλούμε, περιμένετε κάποια λεπτά και προσπαθήστε ξανά.",
		invoicesFilterTitle: "Φιλτράρετε τα τιμολόγια",
		invoicesFilterProduct: "Προϊόν",
		invoicesFilterStatus: "Status",
		invoicesFilterPeriod: "Περίοδος",
		invoiceStatus_paid: "Πληρωμένο",
		invoiceStatus_unpaid: "Απλήρωτο",
		invoiceStatus_overdue: " Εκπρόθεσμο ",
		newOrderTitle: " Νέα παραγγελία ",
		orderStep_1: " Τύπος παραγγελίας",
		orderStep_2: "Προϊόν",
		orderStep_3: "Προσωποποίηση",
		orderStep_4: "Επιβεβαίωση",
		orderStep_5: "Πληρωμή",
		orderStep_1_title: " Τι είδους παραγγελία θέλετε να κάνετε; ",
		orderStep_2_title: " Επιλέξτε προϊόν ",
		orderStep_3_title: "Προσωποποιήστε την παραγγελία σας",
		orderStep_4_title: " Σύνοψη ",
		orderStep_5_title: " Πληρωμή ",
		orderTypePaper: "ΕΝΤΥΠΕΣ ΔΙΑΤΑΚΤΙΚΕΣ",
		orderTypeCard: "ΚΑΡΤΕΣ",
		orderTypeTopup: " Φόρτιση καρτών ",
		orderTypeDuplicate: "ΑΝΤΙΓΡΑΦΗ ΠΑΡΑΓΓΕΛΙΑΣ",
		orderAddBeneficiariesTitle: "Προσθήκη δικαιούχων",
		orderExcelTemplateTitle: " Επεξεργαστείτε την μορφή του Excel που ανεβάσατε",
		orderExcelColumnLabel: " Στήλη {index}:  ",
		orderExcelColumn_0: " Επιλέξτε... ",
		orderExcelColumn_1: "Όνομα",
		orderExcelColumn_2: "Επώνυμο",
		orderExcelColumn_3: " Ταχυδρομικός κώδικας",
		orderExcelColumn_4: "Αριθμός Μητρώου Εργαζομένου",
		orderExcelColumn_5: "Ποσότητα διατακτικών 1",
		orderExcelColumn_6: "Αξία 1",
		orderExcelColumn_7: "Ποσότητα διατακτικών 2",
		orderExcelColumn_8: "Αξία 2",
		orderExcelColumn_9: "Ποσότητα διατακτικών 3",
		orderExcelColumn_10: "Αξία 3",
		orderUploadFileTitle: " Ανεβάστε τη φόρμα παραγγελίας (κατεβάστε το παρακάτω excel)",
		orderFileModelLabel: "Φόρμα παραγγελίας",
		orderFileModelText: "Κατεβάστε τη φόρμα παραγγελίας σας",
		orderFileUploadPlaceholder: "Επιλέξτε αρχείο",
		orderFileUploadButton: "Αναζήτηση",
		orderFileUploadLabel: "Ανέβασμα: ",
		orderFileUploadText: "Συμπληρώστε και ανεβάστε τη φόρμα παραγγελίας",
		orderAddFileButtonLabel: "Προσθήκη",
		nextStepButtonLabel: "ΣΥΝΕΧΕΙΑ",
		saveOrderButtonLabel: "SAVE FOR LATER",
		orderDeliveryTitle: "Επιλογές παραλαβής",
		orderDeliveryCourier: "Αποστολή με κούριερ",
		orderDeliveryPickup: "Παραλαβή από την Up Hellas",
		orderDetailsTitle: " Παραγγελία {orderId} ",
		orderDetailsAddressLabel: "Διεύθυνση τιμολόγησης",
		orderDetailsProductLabel: "Προϊόν",
		orderDetailsNoCardsLabel: "Ποσότητα καρτών",
		orderDetailsNoTicketsLabel: "Αριθμός διατακτικών που παραγγέλθηκαν",
		orderDetailsNominalValueLabel: "Συνολική καθαρή αξία παραγγελίας",
		orderDetailsCommisionLabel: "Συνολική αξία προμήθειας ",
		orderDetailsVatLabel: "Total VAT value ",
		orderDetailsDeliveryFeeLabel: "Συνολική αξία χρέωσης παράδοσης ",
		orderDetailsCardFeeLabel: "Συνολική αξία προμήθειας κάρτας ",
		orderDetailsTotalValueLabel: " Συνολική αξία ",
		orderDetailsDeliveryLabel: " Σημεία παράδοσης ",
		actionUploadFileSuccess: "Το αρχείο ανέβηκε επιτυχώς",
		orderSuccessMessage: " Ευχαριστούμε για την παραγγελία σας. <br /> Μπορείτε να παρακολουθείτε την εξέλιξη της παραγγελίας σας στο μενού παραγγελιών.",
		ordersButtonLabel: "ΑΠΟΣΤΟΛΗ ΠΡΟΤΙΜΟΛΟΓΙΟΥ",
		orderMonthLabel: "Φόρτιση μήνα",
		orderMonth_0: "Επιλογή…",
		orderMonth_1: "Ιανουάριος",
		orderMonth_2: "Φεβρουάριος",
		orderMonth_3: "Μάρτιος",
		orderMonth_4: "Απρίλιος",
		orderMonth_5: "Μάιος",
		orderMonth_6: "Ιούνιος",
		orderMonth_7: "Ιούλιος",
		orderMonth_8: "Αύγουστος",
		orderMonth_9: "Σεπτέμβριος",
		orderMonth_10: "Οκτώβριος",
		orderMonth_11: "Νοέμβριος",
		orderMonth_12: "Δεκέμβριος",
		orderValidFromLabel: " Φόρτιση ενεργή από ",
		orderProformaDateLabel: "Proforma date",
		proformaType_NONE: "PROFORMA TODAY AND LOAD AT PAYMENT",
		proformaType_VALIDFROM: "PROFORMA TODAY AND LOAD IN THE FUTURE",
		proformaType_POSTPONE: "PROFORMA AT A LATER DATE",
		orderValidFromTitle: " Επιλέξτε την ημερομηνία φόρτισης",
		orderProformaDateTitle: "Choose the proforma date*",
		orderPurchaseOrderTitle: "PO – Εντολή Αγοράς (μέγιστο 20 χαρακτήρες)",
		orderGeneralCommentTitle: "Σχόλιο στο τιμολόγιο (μέγιστο 50 χαρακτήρες)",
		orderPersonalizedLabel: " Προσωποποιημένες διατακτικές ",
		orderNotPersonalizedLabel: " Μη προσωποποιημένες διατακτικές ",
		orderPersonalizeVouchersTitle: " Προσωποποιήστε τις διατακτικές σας ",
		orderPersonalizedIconLabel: " Λογότυπο ",
		orderPersonalizedViewIconLabel: " Δείτε το λογότυπο ",
		orderPersonalizedPrintIconLabel: "Εκτύπωση πάνω στη διατακτική",
		orderPersonalizedMessageLabel: "Μήνυμα πάνω στις διατακτικές",
		orderPersonalizedGroupingLabel: "Ομαδοποίηση κουπονιών",
		orderPersonalizedGroupingPlanse: "Πίνακας ελέγχου",
		orderPersonalizedGroupingPachet: "Μεμονωμένες διατακτικές",
		orderPersonalizedGroupingCarnet: "Καρνέ",
		orderStatus_A: "Ακυρώθηκε",
		orderStatus_R: "Not confirmed",
		orderStatus_N: "Καταχωρήθηκε",
		orderStatus_E: "Λάθος",
		orderStatus_P: "Καταχωρήθηκε",
		orderStatus_PR: "Σε εξέλιξη",
		orderStatus_PV: "Σε εξέλιξη",
		orderStatus_S: " Ακυρώθηκε ",
		orderStatus_V: "Ολοκληρώθηκε",
		orderStatus_V2: " Στην εταιρεία κούριερ",
		orderStatus_Z: " Ακυρώθηκε ",
		orderStatus_I: "Επεξεργασία πληρωμής",
		orderPaymentStatusText: "Η πληρωμή σας {data}",
		orderPaymentStatus_A: "ακυρώθηκε",
		orderPaymentStatus_P: "είναι εκκρεμής",
		orderPaymentStatus_V: "είναι εξουσιοδοτημένο",
		orderPaymentStatus_TO: "είναι ο χρόνος εξαντλήθηκε",
		orderPaymentStatus_E: "είναι σε λάθος",
		orderPaymentStatus_Z: "είναι ακυρώθηκε",
		orderPaymentStatus_AA: "ακυρώθηκε",
		orderPaymentStatus_TC: "είναι σε συναλλαγή",
		orderPaymentStatus_400: "είναι δεν βρέθηκε",
		orderPaymentStatus_500: "σε λάθος. Επικοινωνήστε με την ομάδα της Up Hellas",
		orderPaymentStatus_: "",
		defaultAmountValue: " Ορίστε ίδια αξία για όλους τους εργ/νους",
		manualOrderTabTitle: " Μεσω Web",
		excelOrderTabTitle: " Μεσω Excel",
		orderError_DELETE: " Πρόβλημα server. Η παραγγελία σας δεν έχεια ακυρωθεί.",
		orderError_PAYMENT: " Το αίτημα πληρωμής παραγγελίας δεν στάλθηκε με επιτυχία. Παρακαλώ δοκιμάστε ξανά αργότερα.",
		orderError_ALREADY: "Η παραγγελία που προσπαθείτε να πληρώσετε έχει ήδη πληρωθεί με τη χρήση της διαδικτυακής πληρωμής Iris.",
		orderError_PAY_LATER:
			"The proforma email was not sent successfully. Please try again later.",
		orderError_NOTFOUND: "Η παραγγελία που προσπαθείτε να πληρώσετε δεν υπάρχει.",
		orderError_UNAVAILABLE: "Αυτή η επιλογή θα είναι διαθέσιμη αυτόν τον μήνα. Θα επιτρέψει στις κάρτες σας να χρεωθούν σε λιγότερο από 30 λεπτά. Με λίγα κλικ.",
		orderDeleteSuccess: " Η παραγγελία σας διεγράφη με επιτυχία.",
		orderPayRedirect: "Θα ανακατευθυνθείτε στη σελίδα επιλογής τράπεζας. Συνεχίστε με την πληρωμή στο νέο παράθυρο.",
		orderPayLater: "Ελέγξτε την αλληλογραφία σας. Το προτιμολόγιο εστάλη στο email που έχετε δηλώσει στην Up Hellas.",
		beneficiaryVoucherLabel: " Όνομα εργ/νου ή μήνυμα στο εξώφυλλο (προαιρετικό)",
		noOfBookletLabel: " Ποσότητα καρνέ",
		noOfCardLabel: " Ποσότητα καρνέ",
		noOfCardLabelRewards: "Ποσότητα καρτών",
		displayTextLabel: "Όνομα κάρτας",
		cardCarrierTextLabel: "Πληροφορίες φορέα κάρτας",
		employeeIdCardLabel: " Κωδικός κατόχου κάρτας# <br />(προαιρετικό)",
		noTicketsValue1Label1: "Ποσότητα διατακτικών 1",
		amountVoucherLabelPaper: "Συνολική Αξία (αυτόματη συμπλήρωση)",
		amountVoucherLabel: "Αξία φόρτισης ανά κάρτα",
		amountVoucher1Label1: "Αξία 1",
		noTicketsValue1Label2: "Ποσότητα διατακτικών",
		amountVoucher1Label2: "Αξία 1",
		noTicketsValue2Label: "Ποσότητα διατακτικών 2",
		amountVoucher2Label: "Αξία 2",
		noTicketsValue3Label: "Ποσότητα διατακτικών 3",
		amountVoucher3Label: "Αξία 3",
		windowText: "Ποσό στο φάκελο",
		windowText1: "Κείμενο φακέλου 1",
		windowText2: "Κείμενο φακέλου 2",
		windowText3: "Κείμενο φακέλου 3",
		windowText4: "Κείμενο φακέλου 4",
		confirmOrderDelete: " Είστε σίγουρος ότι θέλετε να διαγράψετε την παραγγελία;",
		confirmOrderInfo: "Η πληρωμή σας είναι σε εξέλιξη. Παρακαλούμε μην κλείσετε της σελίδα του IRIS μέχρι να ανακατευθυνθείτε αυτόματα πίσω στην σελίδα της Up.",
		confirmOrderPay: "After you continue you will pay ",
		confirmOrderPay2: " for the order selected.",
		noCrtLabel: "Α/Α",
		orderTableHeaderLabel: "Αριθμός παραγγελίας",
		noProductContract: "Αυτό το προϊόν δεν είναι διαθέσιμο για την εταιρεία σας. Θα πρέπει να υπογράψετε ένα σχετικό συμφωνητικό συνεργασίας με την Up Hellas.",
		productHolidayInfo:
			"Σας ενημερώνουμε ότι οι κάρτες τουρισμού δεν είναι πλέον διαθέσιμες. <br /> <br/> Για παραπάνω πληροφορίες παρακαλώ επικοινωνήστε με τον Account Manager σας.",
		orderCardMessage: "* Προκειμένου οι φορτίσεις να γίνουν την ίδια (εργάσιμη) ημέρα, θα πρέπει η παραγγελία να καταχωρηθεί στην πλατφόρμα και να εξοφληθεί έως τις 17.00.",
		addBeneficiariesTitle: "Προσθήκή νέων δικαιούχων",
		addBeneficiariesTitleRewards: "Ποσότητα καρτών",
		searchPlaceholder: "Αναζήτηση",
		digitalCardsMobileInfo: "* the mobile phone for all beneficiaries must be unique",
		chooseAllAddressOption: "Όλα τα σημεία αποστολής",

		pshysicalCardsTitle: "PHYSICAL CARDS",
		digitalCardsTitle: "DIGITAL CARDS",

		// search company
		searchName: "Αναζήτηση εταιρείας",
		searchPageName: "Αναζήτηση εταιρείας",
		searchByCodall: "Codall",
		searchByProduct: "Προϊόν",
		searchByCompanyName: "Ονομα εταιρείας",
		searchByFiscalCode: "Δημοσιονομικός κώδικας",
		searchButtonLabel: "Αναζήτηση",
		searchNoCompanies: "Δεν υπάρχει εταιρεία για τα επιλεγμένα κριτήρια.",

		paymentButtonLabel: "ΠΛΗΡΩΣΕ ΤΩΡΑ",

		bankingHoursMesage: "01/05/2024 οι πληρωμές που θα πραγματοποιούνται με διατραπεζικό έμβασμα (μεταφορά) θα εκτελούνται στις 02/05/2024  λόγω αργίας , συνεπώς τότε θα πραγματοποιούνται και οι φορτίσεις και τιμολογήσεις που έχουν εξοφληθεί με απλή μεταφορά. Για τις έγκαιρες φορτίσεις κατ' αυτό το διάστημα προτιμήστε τις πληρωμές μέσω IRIS ή RF.",
		ordersHistoryMessage: "Οι παραγγελίες που δεν έχουν οριστικοποιηθεί εντός 1 μήνα από τη δημιουργία τους, θα ακυρώνονται αυτόματα. <br />Αν επιθυμείτε να τις επαναλάβετε, μπορείτε να τις υποβάλετε εκ νέου.",
		millesimeMesage: "Λόγω προγραμματισμένων αναβαθμίσεων στην πλατφόρμα μας, η δυνατότητα καταχώρησης παραγγελιών θα είναι προσωρινά μη διαθέσιμη. Θα επανέλθει κανονικά μετά τις 11:00. Ευχαριστούμε για την κατανόησή σου.",
		"CARD.ERROR.MILLESIME": "Λόγω προγραμματισμένων αναβαθμίσεων στην πλατφόρμα μας, η δυνατότητα καταχώρησης παραγγελιών θα είναι προσωρινά μη διαθέσιμη. Θα επανέλθει κανονικά μετά τις 11:00. Ευχαριστούμε για την κατανόησή σου.",
		splitOrderMessage: "Έχετε πραγματοποιήσει μια παραγγελία που συμπεριλαμβάνει φυσικές και ψηφιακές κάρτες. Επιλέξτε ΑΠΟΣΤΟΛΗ ΠΡΟΤΙΜΟΛΟΓΙΟΥ και θα παραλάβετε άμεσα μέσω email τις δύο αντίστοιχες ειδοποιήσεις πληρωμής τις οποίες μπορείτε να εξοφλήσετε άμεσα κλικάροντας πάνω στον σύνδεσμο πληρωμής.",
		savedOrderMessage: "The order was successfully saved. You can confirm it anytime from the Order menu.",

		gecrNumber: "GECR (GEMI) Number : 136666001000",

		needHelpButton: "ΧΡΕΙΑΖΕΣΑΙ ΒΟΗΘΕΙΑ;",

		bigOrderMessage: "Η παραγγελία σας περιλαμβάνει μεγάλο αριθμό καρτών. Θα χρειαστούν λίγα λεπτά για την δημιουργία της παραγγελίας. Ευχαριστούμε για την υπομονή σας. Θα λάβετε το προτιμολόγιο σας όταν η παραγγελία δημιουργηθεί.",
		loadingMessage: "Please wait. The information is being loaded	",

		// delivery points update
		warningCardAddressPoint: "*Any data changed for an electronic product shall automatically extend to all the productst!",
		sentAddressPointSuccess: "The delivery point was updated successfuly.",
		errorSentAddressPoint_NOT_SENT: "Το σημείο παράδοσης δεν μπορεί να ανανεωθεί.",
		errorSentAddressPoint_ISSS: "Το σημείο παράδοσης δεν μπορεί να ανανεωθεί.",
		errorSentAddressPoint_NOT_FOUND: "Το σημείο παράδοσης δεν υπάρχει.",
		errorSentAddressPoint_PHONE_NOT_VALID: "Ο αριθμός κινητού δεν είναι έγκυρος.",
		errorSentAddressPoint_EMAIL_NOT_VALID: "Η διεύθυνση email δεν είναι έγκυρη.",

		generalErrorMessage: "Αγαπητοί πελάτες,<br />Θα θέλαμε να σας ενημερώσουμε ότι οι συναλλαγές έχουν προσωρινά διακοπεί λόγω τεχνικού προβλήματος της Worldline. Η ομάδα μας εργάζεται εντατικά για την επίλυσή του και αναμένουμε να αποκατασταθεί σύντομα. Ζητούμε την κατανόησή σας και σας ευχαριστούμε για την υπομονή σας.",

	},
];
